import { render, staticRenderFns } from "./BusinessSummaryCard.vue?vue&type=template&id=7a53a30e&scoped=true&"
import script from "./BusinessSummaryCard.vue?vue&type=script&lang=js&"
export * from "./BusinessSummaryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a53a30e",
  null
  
)

export default component.exports